import React, { useState, useEffect,useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import useUsuario from "../../../hooks/useUsuario";
import * as Iconsax from "iconsax-react";
import ToastEva from "../../../components/Toast/ToastEva";
import { ObtenerCapacitacionObligatoriaDocumentosPorId } from "../../../service/CapacitacionService";
import { Skeleton } from "primereact/skeleton";
import * as constantes from "../../../constants/constantes";
import parse from 'html-react-parser'
import CardFile from "../../../components/CardFileEva/CardFile";
import Boton from "../../../components/Boton/Boton";
import "./CapaObligatoria.scss"
//import "./EstilosObligatoria.scss"
const DetalleCapaObligatoria = () => {
    const navigate = useNavigate();
    const [tituloPagina, setTituloPagina] = useState(null);

    const {permisos,isLogged} = useUsuario()
    const [permisoEditar, setPermisoEditar] = useState(true);
    const [capaObligatoria, setCapaObligatoria] = useState(null);
    const toast = useRef(null);
    let { idSeccion } = useParams();
    let { idCapacitacion} = useParams();
    useEffect(()=>{
        !isLogged && navigate("/");
    },[])

    useEffect(()=>{
        const getCapacitacion = async ()=>
        {
            let jwt = window.localStorage.getItem("jwt");
            let Id = idCapacitacion;
            await ObtenerCapacitacionObligatoriaDocumentosPorId({jwt,Id}).then(data => 
                {
                    setCapaObligatoria(data)
                })
        }
        if(!capaObligatoria) getCapacitacion();

    },[idCapacitacion])
    return ( 
        <div className="eva-detalleCapaObligatoria" style={{ marginLeft: 40 }}>
             <ToastEva ref={toast} position="top-center"></ToastEva>
             <div className="eva-dashboard-header">
                <div className="header-agrupado">
                    <div>
                        <i href="#" onClick={() => navigate(-1)} className="p-eva-icon-atras">
                            <Iconsax.ArrowLeft color="#000000" />
                        </i>
                    </div>
                    
                </div>
                
                <div>{capaObligatoria && <label htmlFor="header">{capaObligatoria.nombreCapacitacion}</label>}</div>                                
                
            </div>
            <div className="p-eva-dashboard-detalleCapaObligatoria" style={{ marginTop: 32 }}>
                
                {/* <div className="p-fluid formgrid grid" > */}
                    {
                        capaObligatoria && 
                        capaObligatoria.capacitacion_obligatoria_documentos

                        .filter(x=>x.tipo =="Url"&& x.estado == true).length>0 &&
                         <section style={{ marginBottom: 32 }}>
                            <div className="header-subtitle" style={{ textAlign: "left", marginBottom: 16 }}>
                                <span>Videos de la capacitación</span>
                            </div>
                         {/* <div className="p-fluid formgrid grid gap-3" style={{  gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: "4px" }} > */}
                        <div className=" p-fluid formgrid grid gap-3" style={{ gap: "0px" }} >
                            {
                                capaObligatoria && 
                                capaObligatoria.capacitacion_obligatoria_documentos
                                .filter(x=>x.tipo =="Url"&& x.estado == true)
                                .map((item,i)=>{
                                    var re = /(?:\.([^.]+))?$/;
                                    return (                                        
                                            <div className="field col-12 sm:col-6 md:col-4 lg:col-3" key={i}>
                                                {/* {i==0 && <div className="header-subtitle" style={{width:270,  textAlign: "center"}}>Videos de la capacitación</div>}    */}
                                                <CardFile key={i} extensionArchivo={"video"} nombreArchivo={item.nombreDocumento}  comentario={item.comentario}  keys={i} tipo="Urls" />
                                            </div>                                                                                
                                    );
                                })
                            }
                        </div>
                        </section>
                    }
                
                    {                        
                        capaObligatoria && 
                        capaObligatoria.capacitacion_obligatoria_documentos
                        .filter(x=>x.tipo =="Adjunto"&& x.estado == true).length >0 &&
                        <section style={{ marginBottom: 32 }}>
                            <div className="header-subtitle" style={{ textAlign: "left", marginBottom: 16 }}>
                                <span>Material de apoyo</span>
                            </div>
                        <div className=" p-fluid formgrid grid gap-3" style={{ gap: "0px" }} >                             
                            {
                                capaObligatoria && 
                                capaObligatoria.capacitacion_obligatoria_documentos
                                .filter(x=>x.tipo =="Adjunto"&& x.estado == true)
                                .map((item,i)=>{
                                    var re = /(?:\.([^.]+))?$/;
                                    return (
                                        <div className="field col-12 sm:col-6 md:col-4 lg:col-3" key={i}>
                                            {/* {i==0 && <div className="header-subtitle" style={{width:270, textAlign: "center" }}>Material de apoyo</div>} */}
                                            <CardFile urlFile={constantes.URLBLOB_CAPAOBLIGATORIA + "/" +capaObligatoria.id+"/"+ item.nombreDocumento} 
                                            comentario={item.comentario} 
                                            key={i} extensionArchivo={re.exec(item.nombreDocumento)[1]} 
                                            nombreArchivo={item.nombreDocumento} 
                                            keys={i} tipo="Adjuntos" descargable={true} />
                                        </div>
                                        
                                    );
                                })
                            }
                        </div>
                        </section>
                    }
                    
                {/* </div> */}

                <div className="header-subtitle"><span>¡Es hora de poner en práctica lo aprendido!</span></div>
                <div className="p-eva-labelForm"><span>Este test tiene como objetivo validar los conocimientos aprendidos en la capacitación. Una vez que inicies el test, no podrás salir hasta que lo finalices.</span></div>
                <div style={{display:"flex",justifyContent:"end",paddingTop:16}}>
                    <Boton nombre={"Comenzar"} color="primary" widths="184px"
                        metodoClick={()=>navigate("../Capacitacion/Seccion/" + idSeccion + "/Preguntas/"+idCapacitacion)}
                    ></Boton>
                    </div>
            </div>
        </div>

     );
}
 
export default DetalleCapaObligatoria;